import { render } from "./PostListPage.vue?vue&type=template&id=5fd461a5"
import script from "./PostListPage.vue?vue&type=script&lang=js"
export * from "./PostListPage.vue?vue&type=script&lang=js"
script.render = render

export default script